import { ListItem, ListItemMeta } from '@salecycle/ui-component-library';
import { useAccessLevel, useFeatureFlags } from 'core/app/AppContext';
import { toggleSearchOverlay, usePreferencesDispatch } from 'core/preferences/usePreferencesContext';
import useClient from 'core/ui/utils/useClient';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { getIconColorFromLevel, getIconFromLevel } from '../../../../sections/client-management/utils/ClientHelpers';
import * as RecentClients from '../utils/recentClients';
import { ClientListItemOptions } from './ClientListItemOptions';

export interface Props {
  id: string;
  clientLevel?: string;
}

export const ClientListItem: React.FC<Props> = ({ id, clientLevel }) => {
  const { push } = useHistory();
  const { flagEnabled } = useFeatureFlags();
  const dispatch = usePreferencesDispatch();

  const isBrandDashboardActive = flagEnabled('mps-dashboard-brands');
  const client = useClient(id, clientLevel);
  const settingsPath = 'settings';

  const dashboardClickHandler = () => {
    toggleSearchOverlay(dispatch, false);
    RecentClients.addToLocalStorage(clientLevel, id);
    return push(
      `/${clientLevel}/${id}/${
        clientLevel === 'groups' || (clientLevel === 'brands' && !isBrandDashboardActive) ? settingsPath : 'dashboard'
      }`,
    );
  };

  const icon = getIconFromLevel(clientLevel);
  const iconColor = getIconColorFromLevel(clientLevel);
  const { accessLevel } = useAccessLevel();
  return (
    <>
      <ListItem
        onClick={dashboardClickHandler}
        options={<ClientListItemOptions id={id} level={clientLevel} />}
        tag={
          clientLevel === 'sites' && flagEnabled('ld-hubspot-toggle') && accessLevel === 'SaleCycle'
            ? {
                label: client?.active ? 'Active' : 'Inactive',
                variant: client?.active ? 'active' : 'inactive',
              }
            : undefined
        }
      >
        <ListItemMeta heading={client.name} avatarIcon={icon} avatarBg={iconColor} />
      </ListItem>
    </>
  );
};

export default ClientListItem;
